import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TableManagerService<T extends { refreshData: () => void }> {
  private readonly activeTable = signal<T | null>(null);

  readonly hasActiveTable = computed(() => this.activeTable() !== null);

  register(table: T): void {
    this.activeTable.set(table);
  }

  unregister(): void {
    this.activeTable.set(null);
  }

  refresh(): void {
    const table = this.activeTable();
    if (!table) {
      return;
    }
    table.refreshData();
  }

  getCurrentTable(): T | null {
    return this.activeTable();
  }
}
